import * as maxLength from "ApiMaxLength";
import { HookFormInput } from "components/HookForm/HookFormInput";
import { HookFormPeoplePicker } from "components/HookForm/HookFormPeoplePicker";
import { HookFormSelect } from "components/HookForm/HookFormSelect";
import { HookFormTextArea } from "components/HookForm/HookFormTextArea";
import { InlineSpinner } from "components/InlineSpinner";
import { ResourceKeys, useEditBoardProperties, useEnumChoices, useTranslations } from "providers";
import React from "react";

export const EditBoardPropertiesForm: React.FC = () => {
  const { form, isLoading } = useEditBoardProperties();
  const i18n = useTranslations();
  const { control } = form;
  const { boardStatuses } = useEnumChoices();

  if (!control) return null;

  if (isLoading) {
    return <InlineSpinner text={i18n.Loading} />;
  }

  return (
    <>
      <HookFormInput
        name="shortName"
        control={control}
        label={ResourceKeys.Board_ShortName}
        contextHelp={ResourceKeys.Board_ShortName_Help}
        maxLength={maxLength.boardShortName}
      />

      <HookFormInput
        name="longName"
        control={control}
        label={ResourceKeys.Board_LongName}
        contextHelp={ResourceKeys.Board_LongName_Help}
        maxLength={maxLength.boardLongName}
      />

      <HookFormInput
        name="name"
        control={control}
        label={ResourceKeys.Board_Name}
        contextHelp={ResourceKeys.Board_Name_Help}
        required
        maxLength={maxLength.boardName}
      />

      <HookFormSelect
        name="status"
        control={control}
        label={ResourceKeys.Board_Status}
        contextHelp={ResourceKeys.Board_Status_Help}
        options={boardStatuses}
      />

      <HookFormTextArea
        name="description"
        control={control}
        label={ResourceKeys.Board_Description}
        contextHelp={ResourceKeys.Board_Description_Help}
        maxLength={maxLength.boardDescription}
      />

      <HookFormPeoplePicker
        name="businessOwner"
        control={control}
        label={ResourceKeys.Board_BusinessOwner}
        contextHelp={ResourceKeys.Board_BusinessOwner_Help}
      />

      <HookFormInput
        name="organisationUnit"
        control={control}
        label={ResourceKeys.Board_OrganisationUnit}
        contextHelp={ResourceKeys.Board_OrganisationUnit_Help}
        maxLength={maxLength.boardOrganisationUnit}
      />

      <HookFormInput
        name="edecideId"
        control={control}
        label={ResourceKeys.Board_EdecideId}
        contextHelp={ResourceKeys.Board_EdecideId_Help}
        maxLength={maxLength.boardEdecideId}
      />
    </>
  );
};
